/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_SentInputs */

const en_email_sent = /** @type {(inputs: Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email has been sent`)
};

const nl_email_sent = /** @type {(inputs: Email_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email is verzonden`)
};

/**
* | output |
* | --- |
* | "Email has been sent" |
*
* @param {Email_SentInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_sent = /** @type {((inputs?: Email_SentInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_SentInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_email_sent(inputs)
	return en_email_sent(inputs)
});